
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("djl9a", function(module, exports) {
$parcel$export(module.exports, "ConnectorSetupModalHost", () => (parcelRequire("8TCoR")).ConnectorSetupModalHost);

var $8TCoR = parcelRequire("8TCoR");


});

parcelRegister("fzrJO", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $9639879ef0d0f478$var$initialState = {
    activeConnectorKey: null,
    connectedConnectorKeys: []
};
const $9639879ef0d0f478$var$actions = {
    openSetupModal: (connectorKey)=>({ setState: setState })=>{
            setState({
                activeConnectorKey: connectorKey
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                activeConnectorKey: null
            });
        },
    markConnectorConnected: (connectorKey)=>({ getState: getState, setState: setState })=>{
            const { connectedConnectorKeys: connectedConnectorKeys } = getState();
            if (connectedConnectorKeys.includes(connectorKey)) return;
            setState({
                connectedConnectorKeys: [
                    ...connectedConnectorKeys,
                    connectorKey
                ]
            });
        }
};
const $9639879ef0d0f478$var$SetupConnectorStore = (0, $8s9DV.createStore)({
    initialState: $9639879ef0d0f478$var$initialState,
    actions: $9639879ef0d0f478$var$actions,
    name: 'Twcg1489SetupConnectorStore'
});
const $9639879ef0d0f478$export$86bfee7a4a335f62 = (0, $kBr4q.createActionsHook)($9639879ef0d0f478$var$SetupConnectorStore);
const $9639879ef0d0f478$var$useActiveConnectorKey = (0, $kBr4q.createStateHook)($9639879ef0d0f478$var$SetupConnectorStore, {
    selector: (state)=>state.activeConnectorKey
});
const $9639879ef0d0f478$export$c3af49e60e4baf22 = (0, $kBr4q.createStateHook)($9639879ef0d0f478$var$SetupConnectorStore, {
    selector: (state)=>state.connectedConnectorKeys
});
function $9639879ef0d0f478$export$3ccb24b32789bc60() {
    const activeConnectorKey = $9639879ef0d0f478$var$useActiveConnectorKey();
    const { openSetupModal: openSetupModal, closeModal: closeModal } = $9639879ef0d0f478$export$86bfee7a4a335f62();
    return {
        openSetupModal: openSetupModal,
        activeConnectorKey: activeConnectorKey,
        closeModal: closeModal
    };
}
module.exports["useSetupConnectorActions"] = $9639879ef0d0f478$export$86bfee7a4a335f62;
module.exports["useConnectedConnectorKeys"] = $9639879ef0d0f478$export$c3af49e60e4baf22;
module.exports["useSetupConnector"] = $9639879ef0d0f478$export$3ccb24b32789bc60;

});

parcelRegister("gA25t", function(module, exports) {

let $c121a0a09b4d2dd4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c121a0a09b4d2dd4$var$load("gbejv"),
    $c121a0a09b4d2dd4$var$load("GD9EA"),
    $c121a0a09b4d2dd4$var$load("iNoxQ"),
    $c121a0a09b4d2dd4$var$load("lOm4J"),
    $c121a0a09b4d2dd4$var$load("8zMmc"),
    $c121a0a09b4d2dd4$var$load("dBHUb"),
    $c121a0a09b4d2dd4$var$load("5Rx9J"),
    $c121a0a09b4d2dd4$var$load("hZ2FX"),
    $c121a0a09b4d2dd4$var$load("6wr18"),
    $c121a0a09b4d2dd4$var$load("ilUG7"),
    $c121a0a09b4d2dd4$var$load("efUj2"),
    $c121a0a09b4d2dd4$var$load("aJLFD"),
    $c121a0a09b4d2dd4$var$load("kHXvF"),
    $c121a0a09b4d2dd4$var$load("iWnyc"),
    $c121a0a09b4d2dd4$var$load("fuOfV"),
    $c121a0a09b4d2dd4$var$load("jL1Ke"),
    $c121a0a09b4d2dd4$var$load("5MQ0D"),
    $c121a0a09b4d2dd4$var$load("3O1Rs"),
    $c121a0a09b4d2dd4$var$load("ffEVr"),
    $c121a0a09b4d2dd4$var$load("2EIkU"),
    $c121a0a09b4d2dd4$var$load("hhss7"),
    $c121a0a09b4d2dd4$var$load("Wowvf"),
    $c121a0a09b4d2dd4$var$load("eRhBr"),
    $c121a0a09b4d2dd4$var$load("7EorR"),
    $c121a0a09b4d2dd4$var$load("e0ufb")
]).then(()=>parcelRequire('elniL'));

});

parcelRegister("8TCoR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $fzrJO = parcelRequire("fzrJO");

/* SetupConnectorModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $kSwu1 = parcelRequire("kSwu1");


var $fEPJS = parcelRequire("fEPJS");


var $9Umtx = parcelRequire("9Umtx");


var $aRGok = parcelRequire("aRGok");


var $4ez2K = parcelRequire("4ez2K");


var $lfoFx = parcelRequire("lfoFx");


var $jmjWc = parcelRequire("jmjWc");


var $lsxnT = parcelRequire("lsxnT");


var $7aRa9 = parcelRequire("7aRa9");

const $7b4c3164a2ba2be7$var$styles = {
    loadingContainer: "_1tke1vif"
};
const $7b4c3164a2ba2be7$var$messages = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.setup-connector-modal.error-title",
        defaultMessage: "Connector form could not be loaded"
    },
    errorDescription: {
        id: "experiment-twcg-1489-cc-3p-connector-onboarding.setup-connector-modal.error-description",
        defaultMessage: "Something went wrong. Please try again."
    }
});
const $7b4c3164a2ba2be7$var$loadingContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
    hasCloseButton: true
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), {
    hasInlinePadding: false
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
    xcss: $7b4c3164a2ba2be7$var$styles.loadingContainer,
    justifyContent: "center",
    alignItems: "center"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
    size: "xlarge"
}))));

/**
 * Lazily loaded modal that renders the third-party connector connect form.
 *
 * ModalTransition and Modal are rendered here (in the eagerly-loaded chunk)
 * so the modal backdrop appears immediately while the connector form chunk
 * is loading. The spinner renders inside the modal shell during load.
 *
 * Uses @confluence/loadable (not React.lazy) for Confluence-standard code
 * splitting with SSR compatibility and built-in error handling.
 *
 * The package uses react-relay so Confluence's existing Relay environment
 * is used directly — no additional provider wrapping is needed.
 */ const $7b4c3164a2ba2be7$var$LazyConnectorModalContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "3CACP",
    name: "LazyConnectorModalContent",
    loader: async ()=>(await (parcelRequire("gA25t"))).SetupConnectorModalContent,
    loading: ()=>$7b4c3164a2ba2be7$var$loadingContent
});
function $7b4c3164a2ba2be7$var$SetupConnectorModalWithFlags({ connectorKey: connectorKey, onClose: onClose, flags: flags }) {
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const onError = (0, $cozmU.useCallback)(()=>{
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $7b4c3164a2ba2be7$var$messages.errorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $7b4c3164a2ba2be7$var$messages.errorDescription),
            isAutoDismiss: true
        });
        onClose();
    }, [
        flags,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        width: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4c3164a2ba2be7$var$LazyConnectorModalContent, {
        connectorKey: connectorKey,
        onClose: onClose,
        loadingContent: $7b4c3164a2ba2be7$var$loadingContent,
        onError: onError
    })));
}
const $7b4c3164a2ba2be7$export$c72f879a0467d3fa = (0, $7aRa9.withFlags)($7b4c3164a2ba2be7$var$SetupConnectorModalWithFlags);


function $5d3b6015a7914fc9$export$b07462ee6aa46956() {
    const { activeConnectorKey: activeConnectorKey, closeModal: closeModal } = (0, $fzrJO.useSetupConnector)();
    if (!activeConnectorKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_CFIND
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b4c3164a2ba2be7$export$c72f879a0467d3fa), {
        connectorKey: activeConnectorKey,
        onClose: closeModal
    }));
}
module.exports["ConnectorSetupModalHost"] = $5d3b6015a7914fc9$export$b07462ee6aa46956;

});


//# sourceMappingURL=ConnectorSetupModalHost.d82fa25b.js.map
